module.exports = __webpack_public_path__ + "static/media/cake_tn.05e914eb.jpg";